import Bimester from "./Bimester.js";
import ConsecutiveMonths from "./ConsecutiveMonths.js";
import CustomPeriod from "./CustomPeriod.js";
import Day from "./Day.js";
import FiscalYear from "./FiscalYear.js";
import HalfYear from "./HalfYear.js";
import ModelFactory from "../ModelFactory.js";
import Month from "./Month.js";
import Quarter from "./Quarter.js";
import Week from "./Week.js";

/**
 * Factory class to materialize Period instances.
 */
class PeriodFactory extends ModelFactory {
	allClasses() {
		return [
			Day,
			Week,
			Month,
			Bimester,
			Quarter,
			HalfYear,
			FiscalYear,
			CustomPeriod,
			ConsecutiveMonths,
		];
	}

	_getTypeFromJson(json) {
		return super._getTypeFromJson(json) || json.typeOfPeriod;
	}
}

const periodFactory = new PeriodFactory();

export default periodFactory;
